import type { ProjectPayload } from 'types/Project';
import axios from '../axiosClient';

interface PayloadEligible {
    siren: string;
    country: string;
}

export const eligibleTest = (value: PayloadEligible) => axios.post('/project/egibility/test', value);

export const createAccount = (value: PayloadEligible) => axios.post('/project/register', value);

export const getIsOwner = (idAyomi: number) => axios.get(`/project/is_owner/${idAyomi}`);
export const getInfos = (idAyomi: number) => axios.get(`/project/project/${idAyomi}`);
export const setInfos = (value: ProjectPayload) => axios.post('/project/project', value);

export const getMinAmount = () => axios.get('/project/values/MinAmount');
export const getUrlDashboard = (idAyomi: number) => axios.get(`/project/url/contractor?id_project=${idAyomi}`);
